import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const sandbox = window.location.hostname.match(/^fe-([a-z0-9-]+)\.at-systems\.dev$/)?.[1];
const isSandboxTarget = (url: string): boolean =>
  [environment.api_gateway_service, environment.bff_service].some(target => !!target && url.startsWith(target));

export const sandboxInterceptor: HttpInterceptorFn = (req, next) =>
  sandbox && isSandboxTarget(req.url)
    ? next(req.clone({ setHeaders: { 'X-Sandbox': sandbox } }))
    : next(req);
